var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clothesSizes)?_c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.localStorage.translations.pages['setting-personal_area'].sections['spetsodezhda'],"data":[
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['obuv'],
      value: (_vm.clothesSizes && _vm.clothesSizes.size_shoes) || '-',
    },
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['kurtka'],
      value: (_vm.clothesSizes && _vm.clothesSizes.size_jacket) || '-',
    },
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['shtany'],
      value: (_vm.clothesSizes && _vm.clothesSizes.size_pants) || '-',
    },
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['perchatki'],
      value: (_vm.clothesSizes && _vm.clothesSizes.size_gloves) || '-',
    },
  ],"editReady":_vm.editReady}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }